import { InjectionToken } from '@angular/core';
import { AddressSaveTemplateServiceInterface } from './address-save-template.service.interface';

export const AddressSaveTemplateToken = new InjectionToken<AddressSaveTemplateServiceInterface>(
  'AddressSaveTemplateServiceInterface'
);
